import { Box, Typography } from '@mui/material'
import React from 'react'
import DocumentLoad from "../../assets/documentLoad.webp";

const DocumentLoader = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                height: '100vh',
                width: '100vw',
                top: 0,
                left: 0,
                zIndex: 9999,
                position: 'fixed'
            }}
        >
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column'
                }}
            >
                {/* Replace CircularProgress with GIF */}
                <img
                    src={DocumentLoad}
                    alt="Loading..."
                    style={{
                        width: '200px', // Adjust size as needed
                        marginBottom: '10px'
                    }}
                />
                <Typography
                    sx={{
                        fontWeight: 550,
                        color: '#fff',
                        fontSize: '14px'
                    }}
                >
                    Loading.... Please Wait
                </Typography>
            </div>
        </Box>
    )
}

export default DocumentLoader